// extracted by mini-css-extract-plugin
export default {"input":"input___n9bBn","symbolSelect":"symbolSelect___iaWn9","text":"text___xMuBB","active":"active___YCkNn","inputWrapper":"inputWrapper___wjPTZ"};